const FormMutationTypes = {
  UPDATE_LOADING_STATE: 'UPDATE_LOADING_STATE',
  UPDATE_TEMPLATES: 'UPDATE_TEMPLATES',
  UPDATE_WORK_ORDER_FORM_ID: 'UPDATE_WORK_ORDER_FORM_ID',
  UPDATE_FORMS: 'UPDATE_FORMS',
  UPDATE_FORMS_TO_BE_REMOVED: 'UPDATE_FORMS_TO_BE_REMOVED',
};

export default FormMutationTypes;
